export default __webpack_public_path__ + "static/media/IconEdit.4be792a9.svg";